import { DefaultConfigProps, ThemeDirection, ThemeMode } from '~/types/config';

export const APP_DEFAULT_PATH = '/dashboard/default';
export const BASE_PATH = process.env.REACT_APP_BASE_NAME || '';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

export const IDLE_TIME_LIMIT = 60_000; // 1 minute

const config: DefaultConfigProps = {
  i18n: 'en',
  miniDrawer: false,
  container: false,
  mode: ThemeMode.DARK,
  themeDirection: ThemeDirection.LTR,
};

export default config;
